export const V1_RECEIVE_USER = 'V1_RECEIVE_USER'

export default data => {
  return {
    type: V1_RECEIVE_USER,
    data,
  }
}
